import React from "react";
import { Button, Modal } from "react-bootstrap";
import Style from "./ConfirmModal.module.scss";

function ConformModal({
  isShowModal,
  onOk,
  onClose,
  title,
  caption,
  okText,
  closeText,
  file,
}) {
  return (
    <div>
      <Modal
        show={isShowModal}
        // onHide={() => onClose()}
        style={{ zIndex: 20000 }}
        className={Style.DeleteConfirmmodal}
        backdrop="static"
      >
        {/* <Modal.Header closeButton>
            <Modal.Title>Modal heading</Modal.Title>
          </Modal.Header> */}
        <Modal.Body>
          <div>
            <div>
              {caption ? null : (
                <div>
                  <br />
                </div>
              )}
              <h3 className={Style.HeaderText}>{title}</h3>
            </div>
            <p className={Style.DeleteText}>
              {caption ? (
                caption
              ) : (
                <div>
                  <br />
                </div>
              )}
            </p>
            <div className={Style.BottomSection}>
              <Button
                variant="primary"
                className={Style.cancelBtn}
                onClick={onClose}
              >
                {closeText ? closeText : "Cancel"}
              </Button>
              <Button
                variant="primary"
                className={Style.DeleteBtn}
                //onClick={onOk}
                onClick={() => {onOk(); 
                 
               }}
               // onClick={() => setShowModal(false)}
              >
                {okText ? okText : "OK"}
              </Button>
            </div>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={() => setShowModal(false)}>
              Save Changes
            </Button>
          </Modal.Footer> */}
      </Modal>
    </div>
  );
}

export default ConformModal;
